import { ColDef, ICellRendererParams } from "ag-grid-enterprise";

import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import { CatalogOperator } from "../models/operator";
import { useCatalogOperatorContext } from "../context/CatalogOperatorContext";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  setOperator: (operator: CatalogOperator) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  setOperator,
  setShowModal,
  showContextMenu,
}: Props) => {
  const { state } = useCatalogOperatorContext();

  const rows: CatalogOperator[] =
    state.operators?.map((operator) => ({
      ...operator,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      field: "OperatorName",
      headerName: "Name",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "IsEAF",
      headerName: "EAF",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "IsLMF",
      headerName: "LMF",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "IsCAS",
      headerName: "Caster",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "IsBYI",
      headerName: "BYI",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "IsSY",
      headerName: "SY",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "IsForeman",
      headerName: "Foreman",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "Enabled",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setOperator,
        data: params.data as CatalogOperator,
        del: true,
        setShowModal: setShowModal,
        showContextMenu: () =>
          showContextMenu(event, params.data, "operatorContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 330,
      filter: false,
      autoHeaderHeight: true,
    },
  ];

  return { rows, columnDefs };
};
